/*
 *
 * This class acts somewhat like an interface, the implementor class MUST implement the following methods:
 *    currentMedia: method that returns the current media of the implementor
 *    media: attribute that returns ALL media being managed
 *    nativeRenderer: attribute that returns the renderer, this will most likely be a Kadenze.VideoPlayer
 *
 * This class monitors the state of native media, it will post the state of the currentMedia of the
 * implementor class to the user state, i.e. did they reach the end? where they left off? etc.
 *
 * Why is this so complex you ask? Because the session media player has outgrown it's britches...
 *
 * @params
 *    userId: The current user's id, this user's user_state state will be updated
 *    userType: The current user's enrollment type eg: 'enrolled', 'member', 'public'
 *    implementor: Class that is managing a queue of native media
 *
 * @returns
 *    instance of self
*/
import BaseMonitor from './base';
let NativeMediaSessionMonitor = function() { this.init.apply(this, arguments); };
NativeMediaSessionMonitor.prototype = Kadenze.Util.extendClass(BaseMonitor, {

  getCurrentMedia: function() {
    return this.parent.getCurrentMedia();
  },
});
export default NativeMediaSessionMonitor;
